/** Textos de Eventos (Módulos Claros, 2026-11-01): Title Case en botones, pestañas, chips y encabezados; sin frases explicativas. */
const S = {
	title: "Eventos",
	nuevo: "Nuevo Evento",
	nuevoCorto: "Nuevo",
	volver: "Volver",
	eventos: "‹ Eventos",
	cerrar: "Cerrar",
	cargando: "Cargando…",
	vacio: "Sin eventos.",
	when: { proximos: "Próximos", pasados: "Pasados", anulados: "Anulados" } as { [k: string]: string },
	tipos: { graduacion: "Graduación", batalla: "Batalla", seminario: "Seminario", otro: "Otro" } as { [k: string]: string },
	anulado: "Anulado",
	col: { fecha: "Fecha", evento: "Evento", graduadas: "Graduadas", invitados: "Invitados", cobrado: "Cobrado", pendiente: "Pendiente", invitaciones: "Invitaciones" },
	deCupo: (n: number, cupo: number | null) => cupo ? `${n} / ${cupo}` : String(n),
	nDeM: (n: number, m: number) => `${n} de ${m}`,
	// Formulario
	editar: "Editar",
	guardar: "Guardar",
	crear: "Crear Evento",
	tipo: "Tipo",
	nombre: "Nombre",
	fecha: "Fecha y Hora",
	lugar: "Lugar",
	cupo: "Cupo Máximo",
	porMesa: "Personas por Mesa",
	paquete: "Paquete Graduada",
	invitadoExtra: "Invitado Extra (6+)",
	nino: "Niño",
	paquetes: "Paquete Invitados",
	extras: "Extras",
	extraEjemplo: "Diploma Extra",
	agregarExtra: "Agregar Extra",
	ahorra: (t: string) => `Ahorra ${t}`,
	sinAhorro: "Sin Ahorro",
	ninoGratis: "Niño Gratis",
	nInvitados: (n: number) => n === 1 ? "1 Invitado" : `${n} Invitados`,
	paqueteCorto: (n: number, t: string, nino: boolean) => `${n} por ${t}` + (nino ? " + Niño Gratis" : ""),
	notas: "Notas",
	guardado: "Evento guardado.",
	creado: "Evento creado.",
	anularEvento: "Anular Evento",
	anuladoOk: "Evento anulado.",
	// Detalle
	tabs: { graduadas: "Graduadas", entrada: "Entrada", resultado: "Resultado" },
	agregarGraduadas: "+ Agregar Graduadas",
	imprimirInvitaciones: "Imprimir Invitaciones",
	mas: "Más",
	agregarOtro: "Agregar Otro",
	otrosInvitados: (n: number) => `Otros Invitados (${n})`,
	repartirMesas: "Repartir Mesas",
	buscarGraduada: "Buscar graduada",
	// Columnas de Graduadas
	colGraduada: "Graduada",
	colInvitados: "Invitados",
	colPago: "Pago",
	colInvitacion: "Invitación",
	colEntrada: "Entrada",
	sinInvitados: "Sin Invitados",
	paqueteN: (n: number) => `Paquete ${n}`,
	masNinos: (n: number) => n === 1 ? "+ 1 Niño" : `+ ${n} Niños`,
	faltanNombres: (n: number) => n === 1 ? "falta 1 nombre" : `faltan ${n} nombres`,
	pagadoCompleto: "Pagado Completo",
	falta: (m: string) => `Falta ${m}`,
	extraFalta: (m: string) => `Extra: Falta ${m}`,
	invitacion: { enviada: "Enviada", faltaWhatsapp: "Falta WhatsApp", sinEnviar: "Sin Enviar", sinTelefono: "Sin Teléfono con Lada" } as { [k: string]: string },
	porReenviar: "Por Reenviar",
	participante: "Participante",
	online: "Online",
	// Filtros
	filtroPago: "Pago",
	filtroInvitacion: "Invitación",
	filtroCurso: "Curso",
	pagos: { completo: "Pagado Completo", falta: "Falta Pagar" } as { [k: string]: string },
	limpiar: "Limpiar Filtros",
	sinResultados: "Sin resultados.",
	sinGraduadas: "Sin graduadas.",
	// Ventana de la graduada
	curso: "Curso",
	invitados: "Invitados",
	pago: "Pago",
	mesa: "Mesa",
	diploma: "Diploma",
	diplomaListo: "Listo",
	diplomaFalta: (x: string[]) => "Falta " + x.map(t => t.charAt(0).toUpperCase() + t.slice(1)).join(", "),
	pagadoDe: (p: string, t: string) => `${p} de ${t}`,
	gratisPaquete: "Gratis (Paquete)",
	sinCobro: "Sin Cobro",
	pagado: "Pagado",
	ponerNombre: "Nombre",
	nombreTitulo: (n: string) => `Nombre de ${n}`,
	esNino: "Niño",
	extrasTitulo: "Extras",
	sinEntregar: "Sin Entregar",
	entregado: (c: string) => `Entregado ${c}`,
	entregar: "Entregar",
	quitarEntrega: "Quitar Entrega",
	quitar: "Quitar",
	historia: "Historial",
	enviadaCuando: (c: string, via: string) => `${c}${via ? " · " + via : ""}`,
	via: { whatsapp: "WhatsApp", email: "Correo" } as { [k: string]: string },
	y: " y ",
	soloCorreo: "Solo Correo",
	masInvitados: "+ Invitados",
	venderExtra: "Vender Extra",
	enviarInvitacion: "Enviar Invitación",
	reenviarInvitacion: "Reenviar Invitación",
	copiarEnlace: "Copiar Enlace",
	copiado: "Enlace copiado.",
	pdf: "PDF",
	diplomaPdf: "Diploma",
	baja: "Baja",
	enviando: "Enviando…",
	guardando: "Guardando…",
	waEnviado: "WhatsApp enviado",
	waError: (e: string) => `WhatsApp: ${e}`,
	correoEnviado: "Correo enviado",
	sinCorreo: "Sin correo",
	correoError: (e: string) => `Correo: ${e}`,
	// Historial (una línea)
	h: {
		agregada: "Agregada", invitado: "Invitado", cargo: "Cargo", cargoAnulado: "Cargo Anulado", pago: "Pago", pagoPorAprobar: "Pago por Aprobar", extra: "Extra", extraEntregado: "Entregado",
		invitacion: "Invitación Enviada", whatsapp: "WhatsApp", entrada: "Entrada", rechazada: "Lectura Rechazada", rehabilitada: "Re-habilitada", baja: "Baja", bajaPagada: "Sobrante"
	} as { [k: string]: string },
	waStatus: { enviado: "Enviado", entregado: "Entregado", leido: "Leído", fallido: "Falló" } as { [k: string]: string },
	// + Invitados / Vender Extra / Agregar Otro
	cuantos: "Cuántos",
	nombres: "Nombres",
	revisar: "Revisar",
	confirmar: "Confirmar",
	elegir: "Elegir…",
	extra: "Extra",
	para: "Para",
	precio: "Precio",
	precioEvento: "Precio del Evento",
	motivo: "Motivo",
	seCobra: "Se Cobra",
	kinds: { graduada: "Graduada", invitado: "Invitado", especial: "Especial", externo: "Externo", participante: "Participante" } as { [k: string]: string },
	buscarAlumna: "Nombre o código",
	buscarBtn: "Buscar",
	yaVaA: (evento: string) => `Ya va a ${evento}`,
	agregadoOk: (n: number) => n === 1 ? "Agregado." : `${n} agregados.`,
	extraOk: "Extra vendido.",
	// Qué Va a Pasar
	qvp: "Qué Va a Pasar",
	qvpCalculando: "Calculando…",
	qvpSeAgrega: (n: string, monto: string | null) => monto ? `Se agrega ${n}: se le carga ${monto}.` : `Se agrega ${n} sin cargo.`,
	qvpPaquete: (a: number, b: number) => b === a ? `Se queda con ${b} invitado${b === 1 ? "" : "s"}.` : `Pasa de ${a} a ${b} invitado${b === 1 ? "" : "s"}.`,
	qvpCargo: (quien: string, concepto: string, monto: string) => `Se le carga ${monto} a ${quien} (${concepto}).`,
	qvpPrecio: (n: string, a: string, b: string) => `${n} pasa de ${a} a ${b}.`,
	qvpAnula: (concepto: string, monto: string) => `Se anula ${concepto}: ${monto}.`,
	qvpFaltara: (m: string) => `Le faltará pagar ${m}.`,
	qvpPagadoNoSeToca: "Lo pagado no se toca.",
	qvpSinCambios: "Ningún cobro cambia.",
	qvpTotal: (m: string) => `Total que se carga: ${m}.`,
	qvpAnularEvento: "El evento pasa a Anulado.",
	qvpAnularCobros: (n: number, m: string) => n === 1 ? `Se anula 1 cobro sin abonos (${m}).` : `Se anulan ${n} cobros sin abonos (${m}).`,
	qvpAnularSinCobros: "No hay cobros que anular.",
	qvpAnularInvitaciones: (n: number) => `${n} invitaciones dejan de abrir.`,
	qvpConAbonos: "Con Abonos",
	qvpEditarTitulo: "Cambio de Precios",
	// Agregar Graduadas (antes Elegibles)
	agregarGraduadasTitulo: "Agregar Graduadas",
	elegTodas: "Todas",
	elegListas: "Diploma Listo",
	elegReponer: "Por Reponer",
	cursoTodos: "Todos los Cursos",
	colNombre: "Nombre",
	colCurso: "Curso",
	colTermina: "Termina",
	colAsistencia: "Asistencia",
	colEstado: "Estado",
	nPorReponer: (n: number) => `${n} Por Reponer`,
	yaAgregada: "Agregada",
	agregarN: (n: number) => `Agregar ${n}`,
	cobraPaquete: "Se Cobra el Paquete",
	confirmarLoteTitulo: (n: number) => n === 1 ? "¿Agregar 1 Graduada?" : `¿Agregar ${n} Graduadas?`,
	confirmarLoteCobro: (cada: string, total: string, n: number) => n === 1 ? `Se le carga ${cada}.` : `Se carga ${cada} a cada una (${total} en total).`,
	confirmarLoteSinCobro: "Sin cargo.",
	qvpNoEntra: (nombre: string, motivo: string) => `${nombre}: no entra. ${motivo}`,
	confirmarLoteSi: (n: number) => `Sí, Agregar ${n}`,
	agregadas: (a: number, s: number) => `Agregadas ${a}` + (s ? ` · sin agregar ${s}` : "") + ".",
	mostrando: (n: number, t: number) => `${n} de ${t}`,
	// Baja
	bajaTitulo: (n: string) => `Baja de ${n}`,
	bajaNota: "Nota",
	bajaOk: "Dada de baja.",
	bajaSalen: "Salen",
	bajaPago: "Pagó",
	bajaSeQueda: "Se Queda",
	bajaSobran: "Sobran",
	bajaSoloCaja: "Solo Caja, Contraloría o Super Admin.",
	bajaDestino: "Destino del Sobrante",
	destinos: { saldo: "Saldo a Favor", aplicar: "Pagar Cobros Pendientes", devolucion: "Devolución en Efectivo" } as { [k: string]: string },
	bajaNotaDevolucion: "Nota (Obligatoria)",
	bajaOkDestino: (d: string, monto: string) => d === "saldo" ? `Dada de baja · ${monto} a saldo a favor.`
		: d === "aplicar" ? `Dada de baja · ${monto} aplicado a cobros pendientes.` : `Dada de baja · devolver ${monto} en efectivo.`,
	// Repartir mesas
	conservarManuales: "Conservar Mesas Puestas a Mano",
	repartir: "Repartir",
	mesasOk: "Mesas repartidas.",
	asistentes: "Asistentes",
	// Entrada
	codigo: "Código QR",
	leer: "Leer",
	escanearCamara: "Escanear con Cámara",
	cerrarCamara: "Cerrar",
	camaraTitulo: "Escanear Invitación",
	camaraPrendiendo: "Prendiendo la cámara…",
	camaraSinPermiso: "Permite la cámara en el navegador.",
	camaraNoSoporta: "Este navegador no usa la cámara.",
	camaraApunta: "Apunta al código QR",
	entradas: (n: number, t: number) => `${n} de ${t} Adentro`,
	rehabilitar: "Re-habilitar",
	rehabTitulo: (n: string) => `Re-habilitar a ${n}`,
	rehabNota: "Motivo",
	rehabOk: "Invitación re-habilitada.",
	lecturas: "Lecturas",
	acciones: { entrada: "Entrada", rechazada: "Rechazada", rehabilitada: "Re-habilitada" } as { [k: string]: string },
	invitaA: (n: string) => `Invita ${n}`,
	// Resultado
	ingresos: "Ingresos",
	cobrado: "Cobrado",
	pendiente: "Pendiente",
	costos: "Costos",
	costosOk: "Costos guardados.",
	concepto: "Concepto",
	monto: "Monto",
	agregarCosto: "Agregar Costo",
	// "Bruto" se queda hasta que Esteban elija el nombre nuevo (propuesta en el reporte: «Utilidad» / «Utilidad Cobrada»)
	bruto: "Bruto",
	brutoCobrado: "Bruto Cobrado",
	porTipo: "Por Tipo",
	colTipo: "Tipo",
	cantidad: "Cantidad",
	mesas: "Mesas",
	togas: "Togas y Birretes",
	bajasPagadas: "Bajas con Pago",
	colSobro: "Sobró",
	colDestino: "Destino",
	colQuien: "Quién",
	colCuando: "Cuándo",
	colNota: "Nota"
};

export default S;
